import React, {useEffect, useState} from 'react';
import {Routes, Route, useNavigate, useLocation} from 'react-router-dom';

import './App.css';
import Main from './pages/Main';
import MapGenerated from './pages/MapGenerated';
import IoT from './pages/IoT';
import D3Graph from './pages/D3Graph';
import NoPage from './pages/NoPage';
import Login from './pages/Login';
import Profile from './pages/Profile';
import AdminPage from './pages/Admin';
import AddNewUser from './pages/AddNewUser';
import AddUserGroup from './pages/AddUserGroup';
import {
  UserAccessListV2,
  Documentation,
  UploadDataCenter,
  MapRaster,
  LaporanKerja,
} from './pages';
import UserGroup from './pages/UserGroup';
import UploadPage from './pages/UploadPage';
import MapFiles from './pages/MapFiles';
import DocumentReport from './pages/DocumentReport';
import RequestAccess from './pages/RequestAccess';
import Cookies from 'js-cookie';
// import nookies, {setCookie, destroyCookie} from 'nookies';
import axios from 'axios';

import Header from './components/Header';

import {createTheme, ThemeProvider} from '@mui/material';
import '../src/assets/styles/globals.css';
import {Loader} from './components/Loader';
import {ProtectedRoute} from './components/ProtectedRoute';
import {IoTGraph} from './pages/IoTGraph';
import {UploadIoT} from './pages/UploadIoT/UploadIoT';
import {UploadDocReport} from './pages/UploadDocReport';
import {ManageIoTDevices} from './pages/ManageIoTDevices';
import LintramaxArchiveFiles from './pages/LintramaxArchiveFiles';
import {IconSettings} from './pages/IconSettings';
import MapPreview from './pages/MapPreview';
import ResetPassword from './pages/ResetPassword';
import IotArchiveFiles from './pages/IoT Archive Files';
import {EditDocReport} from './pages/EditDocReport';
import {IOTGraphDataDetail} from './pages/IOTGraphDataDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  const [user, setUser] = useState();
  const [role, setRole] = useState();
  const [isLoad, setLoad] = useState(true);
  const theme = createTheme({
    typography: {
      fontFamily: ['Montserrat'].join(','),
    },
  });
  const location = useLocation();
  const navigate = useNavigate();
  const tokens_session = Cookies.get('token');
  const apiUrl = process.env.REACT_APP_MAIN_URL;

  const checkValid = async () => {
    try {
      const res = await axios.post(
        `${apiUrl}/profile`,
        {},
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
          },
        }
      );
      if (res.data.status === 200) {
        setUser(res.data.data);
        setRole(res.data.data.authority);
      } else if (res.data.status === 401) {
        Cookies.remove('token');
        if (
          location.pathname.split('/')[1] === 'resetpassword' ||
          location.pathname.split('/')[1] === 'privacy-policy' ||
          location.pathname.split('/')[1] === 'request-access'
        ) {
          return;
        }
        navigate('/login');
      }
      setLoad(false);
      return res.data;
    } catch (e) {
      console.log('error', e);
      navigate('/login');
    }
  };

  useEffect(() => {
    if (!tokens_session || tokens_session === 'undefined') {
      setLoad(false);
      if (
        location.pathname.split('/')[1] === 'resetpassword' ||
        location.pathname.split('/')[1] === 'privacy-policy' ||
        location.pathname.split('/')[1] === 'request-access'
      ) {
        return;
      }
      navigate('/login');
    } else {
      Cookies.set('token', tokens_session, {expires: 0.04, path: '/'});
      if (location.pathname.split('/')[1] === 'login') navigate('/');
    }
  }, []);

  useEffect(() => {
    checkValid();
  }, [tokens_session]);

  if (isLoad) {
    return <Loader />;
  } else
    return (
      <ThemeProvider theme={theme}>
        <div className='App' style={{marginTop: '50px'}}>
          {tokens_session && <Header />}
          <Routes>
            {user && (
              <>
                <Route index element={<Main role={role} />} />
                <Route
                  path='adminpage'
                  element={
                    <ProtectedRoute
                      permission={[
                        'digital_mapping_admin',
                        'user_management_admin',
                        'application_management_admin',
                        'kewangan_admin',
                        'atd_admin',
                        'peserta_lot_admin',
                        'pppls_data_admin',
                        'pengesyoran_baja_admin',
                        'documentation_admin',
                      ]}
                      role={role}
                    >
                      <AdminPage user={user} role={role} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='addnewuser'
                  element={
                    <ProtectedRoute
                      permission={['user_management_admin']}
                      role={role}
                    >
                      <AddNewUser />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='addusergroup'
                  element={
                    <ProtectedRoute
                      permission={['user_management_admin']}
                      role={role}
                    >
                      <AddUserGroup />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='graph'
                  element={
                    <ProtectedRoute
                      permission={['lintramax_viewer', 'lintramax_admin']}
                      role={role}
                    >
                      <D3Graph />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='map'
                  element={
                    <ProtectedRoute
                      permission={[
                        'digital_mapping_admin',
                        'digital_mapping_viewer',
                      ]}
                      role={role}
                    >
                      <MapGenerated role={role} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path='mappreview'
                  element={
                    <ProtectedRoute
                      permission={['digital_mapping_admin']}
                      role={role}
                    >
                      <MapPreview role={role} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='laporan-kerja'
                  element={
                    <ProtectedRoute
                      permission={[
                        'digital_mapping_admin',
                        'digital_mapping_viewer',
                      ]}
                      role={role}
                    >
                      <LaporanKerja />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='editdocreport/:data'
                  element={
                    <ProtectedRoute
                      permission={['digital_mapping_admin']}
                      role={role}
                    >
                      <EditDocReport role={role} />
                    </ProtectedRoute>
                  }
                />

                {/* <Route
                path='iot'
                element={
                  <ProtectedRoute
                    permission={['iot_admin', 'iot_viewer']}
                    role={role}
                  >
                    <IoT role={role} />
                  </ProtectedRoute>
                }
              /> */}

                {/* <Route
                path='iotgraph'
                element={
                  <ProtectedRoute
                    permission={['iot_admin', 'iot_viewer']}
                    role={role}
                  >
                    <IoTGraph role={role} />
                  </ProtectedRoute>
                }
              /> */}
                {/* <Route
                path='iotgraph/detail'
                element={
                  <ProtectedRoute
                    permission={['iot_admin', 'iot_viewer']}
                    role={role}
                  >
                    <IOTGraphDataDetail role={role} />
                  </ProtectedRoute>
                }
              /> */}
                <Route
                  path='mapfiles'
                  element={
                    <ProtectedRoute
                      permission={['digital_mapping_admin']}
                      role={role}
                    >
                      <MapFiles />
                    </ProtectedRoute>
                  }
                />

                {/* <Route
                path='iotarchivefiles'
                element={
                  <ProtectedRoute permission={['iot_admin']} user={user}>
                    <IotArchiveFiles />
                  </ProtectedRoute>
                }
              /> */}
                <Route
                  path='lintramaxarchivefiles'
                  element={
                    <ProtectedRoute
                      permission={['lintramax_admin']}
                      role={role}
                    >
                      <LintramaxArchiveFiles />
                    </ProtectedRoute>
                  }
                />
                <Route path='profile' element={<Profile />} />
                <Route
                  path='userlist'
                  element={
                    <ProtectedRoute
                      permission={['user_management_admin']}
                      role={role}
                    >
                      <UserAccessListV2
                        type='user'
                        role={role}
                        setRole={setRole}
                      />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='usergroup'
                  element={
                    <ProtectedRoute
                      permission={['user_management_admin']}
                      role={role}
                    >
                      <UserAccessListV2 type='group' />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='pic'
                  element={
                    <ProtectedRoute
                      permission={['user_management_admin']}
                      role={role}
                    >
                      <UserAccessListV2 type='pic' displayAddBtn={false} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='documentation'
                  element={
                    <ProtectedRoute
                      permission={['documentation_admin']}
                      role={role}
                    >
                      <Documentation type='documentation' />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='program-kerja'
                  element={
                    <ProtectedRoute
                      permission={['application_management_admin']}
                      role={role}
                    >
                      <UploadDataCenter type='programKerja' />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='finance'
                  element={
                    <ProtectedRoute permission={['kewangan_admin']} role={role}>
                      <UploadDataCenter type='finance' />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='application-authorization'
                  element={
                    <ProtectedRoute
                      permission={['application_management_admin']}
                      role={role}
                    >
                      <UploadDataCenter type='applicationAuthorization' />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='atd'
                  element={
                    <ProtectedRoute permission={['atd_admin']} role={role}>
                      <UploadDataCenter type='atd' />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='pengesyoran-baja'
                  element={
                    <ProtectedRoute
                      permission={['pengesyoran_baja_admin']}
                      role={role}
                    >
                      <UploadDataCenter type='pengesyoranBaja' />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path='uploadmap'
                  element={
                    <ProtectedRoute
                      permission={['digital_mapping_admin']}
                      role={role}
                    >
                      <UploadPage />
                    </ProtectedRoute>
                  }
                />
                {/* 
              <Route
                path='uploadiotevent'
                element={
                  <ProtectedRoute permission={['iot_admin']} user={user}>
                    <UploadPage />
                  </ProtectedRoute>
                }
              /> */}

                <Route
                  path='uploadreport'
                  element={
                    <ProtectedRoute
                      permission={['digital_mapping_admin']}
                      role={role}
                    >
                      <UploadDocReport />
                    </ProtectedRoute>
                  }
                />
                {/* <Route
                path='uploadiot'
                element={
                  <ProtectedRoute permission={['iot_admin']} user={user}>
                    <UploadIoT />
                  </ProtectedRoute>
                }
              /> */}
                {/* <Route
                path='manageiotdevices'
                element={
                  <ProtectedRoute permission={['iot_admin']} user={user}>
                    <ManageIoTDevices />
                  </ProtectedRoute>
                }
              /> */}
                {/* <Route
                path='iconsettings'
                element={
                  <ProtectedRoute permission={['iot_admin']} user={user}>
                    <IconSettings />
                  </ProtectedRoute>
                }
              /> */}
                <Route
                  path='upload-finance'
                  element={
                    <ProtectedRoute permission={['kewangan_admin']} role={role}>
                      <UploadPage totalSteps={3} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='upload-documentation'
                  element={
                    <ProtectedRoute
                      permission={['documentation_admin']}
                      role={role}
                    >
                      <UploadPage totalSteps={4} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='upload-pengesyoran-baja'
                  element={
                    <ProtectedRoute
                      permission={['pengesyoran_baja_admin']}
                      role={role}
                    >
                      <UploadPage totalSteps={4} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='upload-atd'
                  element={
                    <ProtectedRoute permission={['atd_admin']} role={role}>
                      <UploadPage totalSteps={4} />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path='uploadreport'
                  element={
                    <ProtectedRoute
                      permission={['digital_mapping_admin']}
                      role={role}
                    >
                      <UploadPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='uploadpalm'
                  element={
                    <ProtectedRoute
                      permission={['lintramax_admin']}
                      role={role}
                    >
                      <UploadPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='uploadpaddy'
                  element={
                    <ProtectedRoute
                      permission={['lintramax_admin']}
                      role={role}
                    >
                      <UploadPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='uploadrubber'
                  element={
                    <ProtectedRoute
                      permission={['lintramax_admin']}
                      role={role}
                    >
                      <UploadPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='participants-and-lot'
                  element={
                    <ProtectedRoute
                      permission={['peserta_lot_admin']}
                      role={role}
                    >
                      <UploadDataCenter type='participantAndLot' />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='upload-participants-and-lot'
                  element={
                    <ProtectedRoute
                      permission={['peserta_lot_admin']}
                      role={role}
                    >
                      <UploadPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='pppls'
                  element={
                    <ProtectedRoute
                      permission={['pppls_data_admin']}
                      role={role}
                    >
                      <UploadDataCenter type={'pppls'} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='upload-pppls'
                  element={
                    <ProtectedRoute
                      permission={['pppls_data_admin']}
                      role={role}
                    >
                      <UploadPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path='documentreport'
                  element={
                    <ProtectedRoute
                      permission={['digital_mapping_admin']}
                      role={role}
                    >
                      <DocumentReport />
                    </ProtectedRoute>
                  }
                />

                <Route path='*' element={<NoPage />} />
              </>
            )}
            <Route
              path='/request-access/:token_user/:id/:status/:pk_code'
              element={<RequestAccess />}
            />
            <Route path='/resetpassword/:token' element={<ResetPassword />} />
            <Route path='/login' element={<Login />} />
            <Route path='/privacy-policy/adms' element={<PrivacyPolicy />} />
          </Routes>
        </div>
      </ThemeProvider>
    );
}

export default App;
